export default __webpack_public_path__ + "30df4325ff01acf5ec742b190cd5dbbf.svg";